import { z } from "zod";

export interface RequestPolicy {
  id: number;
  aplicaA: string[];
  nombre: string;
  clase: string;
  valor: string;
  activo: boolean;
}

export interface RequestPolicyDetail {
  idPoliticaSolicitud: number;
  idTipoSolicitud: number[];
  nombrePolitica: string;
  clase: string;
  valor: string;
  activo?: boolean;
}

export enum ClasePoliticaEnum {
  TopeDiario = "Tope diario",
  RangoSemanal = "Rango semanal",
  Horario = "Horario",
  TopeChequesRespaldo = "Tope para cheques respaldo"
}

export const requestPolicySchema = z.object({
  clase: z.any().optional(),
  nombre: z.any().optional(),
  tipoSolicitud: z.array(z.any().optional()).optional(),
  monto: z.any().optional(),
  dias: z.array(z.any().optional()).optional(),
  horaDesde: z.string().optional(),
  horaHasta: z.string().optional(),
  activo: z.boolean().optional(),
});
